import { useMemo } from 'react';
import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const padding = Platform.select({ ios: 12, android: 16, default: 16 });

export const usePlatformPadding = (respectInsets = false) => {
  const insets = useSafeAreaInsets();

  return useMemo(
    () => ({
      top: respectInsets ? Math.max(insets.top, padding) : padding,
      bottom: respectInsets ? Math.max(insets.bottom, padding) : padding,
      left: respectInsets ? Math.max(insets.left, padding) : padding,
      right: respectInsets ? Math.max(insets.right, padding) : padding,
    }),
    [respectInsets, insets.top, insets.bottom, insets.left, insets.right]
  );
};
